// Export all icons
export * from "./icons";

// Export the AnxIcon component itself
export * from "../../components/AnxIcon/AnxIcon.vue";

// Export the plugin to enable global registering of icons
export { AnxIconsPlugin, AnxIconsNames } from "./plugin";
